<template>
  <ul class="history-list">
    <li :key="index" :class="['history-item','buy-item', {'draw-item': !item.gems}]" v-for="(item, index) in history">
      <div :class="['item-wrap']">
        <Item
          :key="index"
          v-bind={img_url:item.item_img,item_num:item.item_num}>
        </Item>
        <Marquee class="item-name" :text="item.item_name"></Marquee>
      </div>
      <Gems :gems="item.gems" v-if="item.gems>0"></Gems>
      <span class="item-date">{{formatDate(item.created_at)}}</span>
    </li>
  </ul>
</template>
<script>
import Item from '@/components/item/index.vue'
import Gems from '@/components/gems/index.vue'
  export default {
    data() {
      return {}
    },
    computed: {
      isShow: {
        get() {
          return this.show
        },
        set(val) {
          this.$emit('update:show', val)
        }
      }
    },
    inheritAttrs: true,
    components:{
      Item,
      Gems
    },
    props: {
      show: Boolean,
      history: Array
    },
    methods: {
      formatDate(num) {
        return new Date(num * 1000).toLocaleString()
      }
    }
  }
</script>
<style lang="scss" scoped>
  .history-modal {
    .history-list {
      margin: 0 1vw 0;
      @include res-size($font-size: 28px);
      .history-item {
        position: relative;
        @include flexrc;
        @include res-size($height: 146px);
        justify-content: space-between;
        border-bottom: 1px solid #082c2b;
        .item-date {
          @include res-size(
            $width: 195px
          )
        }
        .item-wrap {
          @include flexrc;
          justify-content: space-between;
          @include res-size(
            $width: 315px
          )
          .item{
            @include res-size(
              $width: 110px,
              $height: 110px
            )
          }
          .item-name {
            word-wrap: break-word;
            text-align: left;
            @include res-size(
              $width: 160px
            )
          }
          .item-img {
            flex-shrink: 0;
            position: relative;
            @include res-size(
              $width: 137px,
              $height: 106px
              
            );
            @include bgc;
            @include flexrc;
            img {
              width: 70%;
              height: 70%;
              object-fit: contain;
            }
          }
        }
        .gems{
          justify-content: start;
          @include res-size(
            $width: 100px
          )
        }
      }
      .history-item:last-child{
        border: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/history/index.vue